const translation = {
  labels: {
    modals: {
      saveButton: "Save",
      cancelButton: "Cancel",
    },
    contactInformation: {
      changeContactInformation: "Change contact information",
      contactInformation: "Contact information",
      yourEmailAddress: "Your email address",
      changeEmailAddress: "Change email address",
      shareOrder: "Interested in sharing this order with colleagues?",
      chooseEmailAddress:
        "Choose an email address from existing ones within your company or add a new role",
      addEmailAddress: "Add email address",
      enterEmailAddress: "Enter new email address",
      saveEmailAddress: "Save",
    },
    paymentOptions: {
      paymentOptions: "Payment options",
      changePaymentOptions: "Change payment options",
      paymentMethod: "Payment method",
      creditCard: "Credit Card",
      onAccount: "On Account",
      paymentMethodDescription:
        "Payment per credit card is powered by Ayden payment platform. By choosing this payment method you accept our cookies requirement. If you do not agree to this cookie requirement, please opt-out here. A credit card payment is not possible",
      cookiePolicy: "I have read and agree to the cookie policy",
      paymentNote:
        "Please note: After the review page you will be redirected to the credit card payment. There you will be able to enter your credit card details.",
      billingAddress: "Billing address",
      useShippingAddress: "Use shipping address as billing address",
      changeBillingAddress: "Change billing address",
    },
    deliveryOptions: {
      changePaymentOptions: "Change delivery options",
      deliveryOptions: "Delivery options",
      descriptionFirstParagraph:
        "If you change your delivery option in this process stage, we need to re-verify your order due to product availability & prices.",
      descriptionSecondParagraph:
        "This might take up to 2 minutes. You will then be redirected to the shopping cart.",
      preferredDelivery: "Preferred delivery",
      completeDelivery: "Complete delivery",
      partialDelivery: "Partial delivery",
      shippingMethod: "Shipping method",
      standard: "Standard",
      express: "Express",
      shippingAddress: "Shipping address",
      changeShippingAddress: "Change shipping address",
      cancelButton: "Cancel & go to review",
      verifyOrderButton: "Verify order & go to cart"
    },
    cartFlyout: {
      yourCartsText: "Your Carts",
      quickAddText: "Quick Add",
      cartQuantityText: "Quantity:",
      cartIdText: "Cart for order:",
      cartCheckoutButtonText: "Proceed to checkout",
      addProductsButtonText: "Add products",
      totalPriceText: "Total",
      seeAllText: "See all",
      productsText: "Products",
      cartEmptyCartMessage: "No carts",
      cartListPriceText: "List Price"
    }
  }
}

export default translation;
